import { isEmpty } from "lodash";
import numeral from "numeral";
import React, { useMemo } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const ProgramsPerformance = ({ onClickProgram }) => {
  const { data } = useSelector((state) => ({
    data: state.dashboardReducer.overall.charts.financialReportByPrograms,
  }));

  const totals = useMemo(() => {
    if (isEmpty(data)) return { fund: 0, expenditure: 0, balance: 0, percentage: 0 };
    const fund = data.reduce((acc, item) => acc + parseFloat(item.fund), 0);
    const expenditure = data.reduce((acc, item) => acc + parseFloat(item.expenditure), 0);
    return { fund, expenditure, balance: fund - expenditure, percentage: (expenditure / fund) * 100 };
  }, [data]);

  return (
    <React.Fragment>
      <Table hover size='sm' style={{ fontSize: "12px", fontWeight: 700 }}>
        <thead className='text-center'>
          <tr className='text-uppercase'>
            <th>Nama Program</th>
            <th>
              Peruntukan<div>(RM)</div>
            </th>
            <th>
              Perbelanjaan<div>(RM)</div>
            </th>
            <th>
              Baki Peruntukan<div>(RM)</div>
            </th>
            <th>Peratus Perbelanjaan</th>
          </tr>
        </thead>
        <tbody className='text-end'>
          {data?.map((item, idx) => {
            const expenditurePercentage =
              (item.expenditure / item.fund) * 100 || 0;
            const currentBalance =
              parseFloat(item.fund) - parseFloat(item.expenditure);
            return (
              <tr
                key={idx}
                style={{ cursor: "pointer" }}
                onClick={() => onClickProgram(item.id)}
              >
                <td className='text-start ps-2'>{item.name}</td>
                <td
                  className='text-white'
                  style={{ backgroundColor: "#64b5f6" }}
                >
                  {numeral(item.fund).format("0,0.00")}
                </td>
                <td
                  className='text-white'
                  style={{ backgroundColor: "#81c784" }}
                >
                  {numeral(item.expenditure).format("0,0.00")}
                </td>
                <td>{numeral(currentBalance).format("0,0.00")}</td>
                <td className='text-center'>
                  {expenditurePercentage.toFixed(2)} %
                </td>
              </tr>
            );
          })}
          <tr style={{ borderTop: "double" }}>
            <td className='text-start text-uppercase'>Jumlah</td>
            <td className='text-white' style={{ backgroundColor: "#64b5f6" }}>
              {numeral(totals.fund).format("0,0.00")}
            </td>
            <td className='text-white' style={{ backgroundColor: "#81c784" }}>
              {numeral(totals.expenditure).format("0,0.00")}
            </td>
            <td>{numeral(totals.balance).format("0,0.00")}</td>
            <td className='text-center'> {totals.percentage.toFixed(2)} %</td>
          </tr>
        </tbody>
      </Table>
    </React.Fragment>
  );
};

export default ProgramsPerformance;
